export const TREATMENT_HISTORY_VIEW = 'TREATMENT_HISTORY_VIEW';
export const TREATMENT_HISTORY = 'TREATMENT_HISTORY';
export const TREATMENT_HISTORY_ROWS = 'TREATMENT_HISTORY_ROWS';
export const TREATMENT_HISTORY_ITEMS = `TREATMENT_HISTORY_ITEMS`;
export const generateTreatmentHistoryItemsFocusKey = (index: number) =>
  `${TREATMENT_HISTORY_ITEMS}_${index}`;
export const TREATMENT_HISTORY_FIRST = generateTreatmentHistoryItemsFocusKey(0);
export const TREATMENT_HISTORY_EMPTY = 'TREATMENT_HISTORY_EMPTY';
export const TREATMENT_HISTORY_HOME = 'TREATMENT_HISTORY_HOME';
